import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export interface GetSchoolReportQuotesResponse {
  eoa_school_id: string;
  student_voices_focus_group_summary_1: string | null;
  student_voices_focus_group_summary_2: string | null;
  student_voices_focus_group_summary_3: string | null;
  student_voices_focus_group_summary_4: string | null;
  key_findings_ending_student_voice: string | null;
  college_eligibility_student_voices_1_1: string | null;
  college_eligibility_student_voices_1_2: string | null;
  college_eligibility_student_voices_2_1: string | null;
  college_eligibility_student_voices_2_2: string | null;
  college_readiness_student_voices_1_1: string | null;
  college_readiness_student_voices_1_2: string | null;
  college_readiness_student_voices_2_1: string | null;
  college_readiness_student_voices_2_2: string | null;
  pss_via_cte_student_voices_1: string | null;
  pss_via_cte_student_voices_2: string | null;
  next_steps_student_voices: string | null;
  key_findings_ending_student_voice_is_skip: boolean;
  college_eligibility_student_voices_1_is_skip: boolean;
  college_eligibility_student_voices_2_is_skip: boolean;
  college_readiness_student_voices_1_is_skip: boolean;
  college_readiness_student_voices_2_is_skip: boolean;
  pss_via_cte_student_voices_is_skip: boolean;
  next_steps_student_voices_is_skip: boolean;
}

export interface PatchSchoolReportQuotesResponse {
  id: string;
  eoa_school_id: string;
}

export interface JsonPatchOperation {
  op: 'replace' | 'remove' | 'test';
  path: string;
  value?: string | boolean;
}

const getSchoolReportQuotes = async (
  eoaId: string,
  schoolId: string,
  access_token: string
): Promise<GetSchoolReportQuotesResponse> => {
  const response = await axios.get<GetSchoolReportQuotesResponse>(
    `${BASE_URL}/eoa/${eoaId}/schools/${schoolId}/report_quotes`,
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );

  return response.data;
};

const patchSchoolReportQuotes = async (
  eoaId: string,
  schoolId: string,
  access_token: string,
  patchOperations: JsonPatchOperation[]
): Promise<PatchSchoolReportQuotesResponse> => {
  const response = await axios.patch<PatchSchoolReportQuotesResponse>(
    `${BASE_URL}/eoa/${eoaId}/schools/${schoolId}/report_quotes`,
    patchOperations,
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data;
};

export { getSchoolReportQuotes, patchSchoolReportQuotes };
